// extracted by mini-css-extract-plugin
module.exports = {"Gallery":"Gallery_Gallery__234FM","Images":"Gallery_Images__l2ylo","Image":"Gallery_Image__8bb3E"};